import React from 'react';
import { isEqual } from 'lodash';

import {
  HistoryResponseModel,
  CustomerHistoryDetailsModel,
} from 'api/adminApiClient';
import GeneralInformationDetailsCard from './Primary/GeneralInformationDetailsCard';
import BillingInformationDetailsCard from './Primary/BillingInformationDetailsCard';
import AdditionalInformationDetailsCard from './Primary/AdditionalInformationDetailsCard';
import AgreementDetailsCard from './Primary/AgreementDetailsCard';
import GeneralContractInfoDetailsCard from './Additional/GeneralContractInfoDetailsCard';
import FinancialInfoDetailsCard from './Additional/FinancialInfoDetailsCard';
import AdditionalInformation3DetailsCard from './Additional/AdditionalInformation3DetailsCard';

type Props = {
  customerId: string;
  historyItem: HistoryResponseModel;
};

export default function CustomerDetailsCard(props: Props) {
  const { historyItem, customerId } = props;
  const historyDetails = historyItem.details as CustomerHistoryDetailsModel;
  const historyId = historyItem.id || '';

  return (
    <>
      {!isEqual(
        historyDetails.oldData?.generalInfo,
        historyDetails.newData?.generalInfo,
      ) && (
        <>
          {!isEqual(
            historyDetails.oldData?.generalInfo?.generalInfo,
            historyDetails.newData?.generalInfo?.generalInfo,
          ) && (
            <GeneralInformationDetailsCard
              historyDetails={historyDetails}
              historyId={historyId}
            />
          )}

          {!isEqual(
            historyDetails.oldData?.generalInfo?.billingInfo,
            historyDetails.newData?.generalInfo?.billingInfo,
          ) && (
            <BillingInformationDetailsCard
              historyDetails={historyDetails}
              historyId={historyId}
            />
          )}

          {!isEqual(
            historyDetails.oldData?.generalInfo?.additionalInfo,
            historyDetails.newData?.generalInfo?.additionalInfo,
          ) && (
            <AdditionalInformationDetailsCard
              historyDetails={historyDetails}
              historyId={historyId}
            />
          )}

          {!isEqual(
            historyDetails.oldData?.generalInfo?.agreementDetailsInfo,
            historyDetails.newData?.generalInfo?.agreementDetailsInfo,
          ) && (
            <AgreementDetailsCard
              customerId={customerId}
              historyDetails={historyDetails}
              historyId={historyId}
            />
          )}
        </>
      )}

      {!isEqual(
        historyDetails.oldData?.additionalInfo,
        historyDetails.newData?.additionalInfo,
      ) && (
        <>
          {!isEqual(
            historyDetails.oldData?.additionalInfo?.contractInformation,
            historyDetails.newData?.additionalInfo?.contractInformation,
          ) && (
            <GeneralContractInfoDetailsCard
              customerId={customerId}
              historyDetails={historyDetails}
              historyId={historyId}
            />
          )}

          {!isEqual(
            historyDetails.oldData?.additionalInfo?.financialInformation,
            historyDetails.newData?.additionalInfo?.financialInformation,
          ) && (
            <FinancialInfoDetailsCard
              customerId={customerId}
              historyDetails={historyDetails}
              historyId={historyId}
            />
          )}

          {!isEqual(
            historyDetails.oldData?.additionalInfo?.assignmentInformation,
            historyDetails.newData?.additionalInfo?.assignmentInformation,
          ) && (
            <AdditionalInformation3DetailsCard
              customerId={customerId}
              historyDetails={historyDetails}
              historyId={historyId}
            />
          )}
        </>
      )}
    </>
  );
}
